import styled from "styled-components";
import Logo from "./Logo";
import User from "../modules/authentication/User";
import Navbar from "../modules/menu/Navbar";
import Settings from "../modules/settings/Settings";
import TodaysLunchMeal from "./TodaysLunchMeal";
import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";

//#region styles
const StyledHeader = styled.header.attrs(() => ({ id: "app-header" }))`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: var(--color-grey-main);
  padding: 0.8rem 2.8rem; //Margins to inside elements
  margin: 0.4rem 0.8rem; // Add top and bottom margins
  width: calc(100% - 1.6rem);
  box-shadow: var(--shadow-main);
  align-items: center;
  justify-content: space-between;
`;

const StyledAppContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledUserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center; // Ensure vertical alignment
`;

const StyledAppName = styled.h1`
  font-size: 1.2em;
  color: var(--color-witron-blue);
  margin-left: 1em;
  text-transform: capitalize;

  align-self: center;
`;

//#endregion

function Header() {
  const { isLocation, userDetails } = useContext(UserContext);
  
 
  
  return (
    <StyledHeader>
      <StyledAppContainer>
        <Logo />
        <StyledAppName>WiMule | {import.meta.env.VITE_LOCATION}</StyledAppName>
        <Navbar />
      </StyledAppContainer>
      <TodaysLunchMeal />

      <StyledUserContainer>
        <User />
        <Settings />
      </StyledUserContainer>
    </StyledHeader>
  );
}

export default Header;
